import $ from 'jquery';
const InitRestartContactGallery = (el) => {
    const $el = $(el);
    $el.on('mouseenter', function() {
        const galleryImages = $(this).find('.contact__gallery-image');
        galleryImages.each(function() {
            const clonedImage = $(this).clone(true);
            $(this).replaceWith(clonedImage);
        });
    });
};

export default InitRestartContactGallery;
